// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__w3McH"};